
import * as defaultImport from "@splunk/react-icons/ExclamationTriangle";
export * from "@splunk/react-icons/ExclamationTriangle";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
